import { PRODUCT_REMARK_DEFAULT_VALUES } from './common';

const ROOT_NUMBER_FIELDS = new Set([
  'type',
  'memberId',
  'receptionistId',
  'storeId',
  'settlementType',
  'memberPaymentAccountType',
  'memberPaymentAccountSubType',
  'isTradeIn',
]);

const PRODUCT_NUMBER_FIELDS = new Set([
  'quantity',
  'finalSalePrice',
  'finalRecyclePrice',
  'price',
  'firstValuationStock',
  'authenticationBagId',
  'quoteStaffId',
]);

const toNumberOrKeep = (value: unknown) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : value;
  }

  if (typeof value === 'string') {
    const trimmedValue = value.trim();
    if (trimmedValue === '') return undefined;

    const parsedValue = Number(trimmedValue);
    return Number.isFinite(parsedValue) ? parsedValue : value;
  }

  return value;
};

const normalizeProduct = (product: Record<string, any>) => {
  const normalizedProduct: Record<string, any> = {
    ...PRODUCT_REMARK_DEFAULT_VALUES,
    ...product,
  };

  PRODUCT_NUMBER_FIELDS.forEach((field) => {
    if (field in normalizedProduct) {
      normalizedProduct[field] = toNumberOrKeep(normalizedProduct[field]);
    }
  });

  if (Array.isArray(normalizedProduct.productCategoryIdList)) {
    normalizedProduct.productCategoryIdList =
      normalizedProduct.productCategoryIdList.map((value: unknown) =>
        toNumberOrKeep(value),
      );
  }

  return normalizedProduct;
};

export const normalizeRecyclingConsignmentDraftData = (
  values: Record<string, any>,
) => {
  const normalizedValues = { ...values };

  ROOT_NUMBER_FIELDS.forEach((field) => {
    if (field in normalizedValues) {
      normalizedValues[field] = toNumberOrKeep(normalizedValues[field]);
    }
  });

  if (Array.isArray(normalizedValues.productList)) {
    normalizedValues.productList = normalizedValues.productList.map(
      (product: Record<string, any>) => normalizeProduct(product),
    );
  }

  return normalizedValues;
};
